import React from 'react';
import { Box } from '@mui/material';
import { fontFamilyMono, radius } from '../../theme/tokens';

/**
 * A license plate as a small outlined tag in monospace, so plates read as
 * identifiers rather than prose and line up down a table column.
 */
const LicensePlate: React.FC<{ plate: string }> = ({ plate }) => (
  <Box
    component="span"
    sx={{
      display: 'inline-block',
      flexShrink: 0,
      px: 0.75,
      py: '1px',
      fontFamily: fontFamilyMono,
      fontSize: '0.6875rem',
      fontWeight: 600,
      lineHeight: 1.5,
      letterSpacing: '0.02em',
      whiteSpace: 'nowrap',
      color: 'text.secondary',
      border: 1,
      borderColor: (t) => (t.palette.mode === 'light' ? t.palette.grey[300] : t.palette.grey[700]),
      borderRadius: `${radius.xs - 2}px`,
    }}
  >
    {plate}
  </Box>
);

export default LicensePlate;
